/** @jsxImportSource @emotion/react */
import { useEffect, useState, useRef } from "react";
import { accessAPI, Titulo, tituloBase } from "../../shared";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Divider } from "primereact/divider";
import { Boton } from "../../shared";

export default function BusquedaResultado() {
  const [resultados, setResultados] = useState([]);
  const [loader, setLoader] = useState(true);
  const { buscar } = useParams();
  const navigate = useNavigate();
  const toast = useRef(null);

  useEffect(() => {
    document.title = "Resultado de la búsqueda";
    if (buscar) {
      setLoader(true);
      accessAPI(
        "GET",
        `admin/buscador/buscarDatos?query=${encodeURIComponent(buscar)}`,
        null,
        (respuesta) => {
          const totalItems = respuesta.reduce((sum, grupo) => sum + (grupo.items?.length || 0), 0);
          if (totalItems === 1) {
            const unicoItem = respuesta.find((g) => g.items?.length)?.items[0];
            navigate(unicoItem.url, { replace: true });
            return;
          }
          setResultados(respuesta);
          setLoader(false);
        },
        (error) => {
          setLoader(false);
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: error[0]?.msg || "Error al buscar",
            sticky: true
          });
        }
      );
    }
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscar]);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Titulo urlVolver="/">Resultados de "{buscar}"</Titulo>

      {loader && (
        <Card>
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {[...Array(5)].map((_, i) => (
              <Skeleton key={i} width="100%" height="2.5rem" />
            ))}
          </div>
        </Card>
      )}

      {!loader && resultados.length === 0 && (
        <Card>
          <p css={{ color: "var(--grisTextos)" }}>
            No se encontraron resultados para "{buscar}".
          </p>
        </Card>
      )}

      {!loader && resultados.length > 0 && (
        <Card>
          {resultados.map((grupo, index) => (
            <div key={grupo.etiqueta}>
              {index > 0 && <Divider />}
              <h3 css={{ margin: "0 0 0.5rem 0", fontSize: "1rem" }}>
                {grupo.etiqueta}
              </h3>
              <div
                css={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.25rem"
                }}
              >
                {grupo.items.map((item, i) => (
                  <Boton
                    key={i}
                    texto
                    callback={(e) => {
                      if (e?.metaKey || e?.ctrlKey) {
                        window.open(item.url, "_blank");
                      } else {
                        navigate(item.url);
                      }
                    }}
                  >
                    {item.etiqueta}
                  </Boton>
                ))}
              </div>
            </div>
          ))}
        </Card>
      )}
    </>
  );
}
